import React, { useEffect, useContext, useState } from 'react';
import { AuthContext } from 'contexts/AuthContext';
import branchService from 'ApiService/SuperAdmin/branchService';

const SelectBranch = ({ onClose = () => {} }) => {
  const { state, dispatch } = useContext(AuthContext);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBranches = async () => {
    try {
      const response = await branchService.allBranches();
      const sortedBranches = [...response.data.allBranches].sort((a, b) =>
        b.name.localeCompare(a.name)
      );
      setBranches(sortedBranches);
    } catch (error) {
      console.error('Error fetching branches:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBranches();
  }, []);

  const handleBranchChange = (event) => {
    const selectedBranchId = event.target.value;
    dispatch({ type: 'SET_SELECTED_BRANCH', payload: selectedBranchId });
    onClose && onClose();
  };

  if (loading) return <div>Loading branches...</div>;

  return (
    <select
      className="rounded border-none p-2 text-navy-700 outline-none dark:bg-navy-800 dark:text-white"
      onChange={handleBranchChange}
      value={state.selectedBranch || ''}
    >
      <option value="" disabled>
        Select Branch
      </option>
      {branches.map((branch) => (
        <option key={branch._id} value={branch._id}>
          {branch.name.charAt(0).toUpperCase() + branch.name.slice(1)} (
          {branch.location.charAt(0).toUpperCase() + branch.location.slice(1)})
        </option>
      ))}
    </select>
  );
};

export default SelectBranch;
